import cn from './risk-form.module.css';

const RiskFormItem = ({
  title,
  children,
}: {
  title: string;
  children: React.JSX.Element;
}) => (
  <div className={cn.riskFormItem}>
    <div className={cn.riskFormTitle}>{title}</div>
    {children}
  </div>
);

export default RiskFormItem;
